export enum WebsocketResponseTypes {
  LLM_ANSWER = "LLM_ANSWER",
  SERVER_ERROR = "SERVER_ERROR",
  TOKEN_ANALYTICS = "TOKEN_ANALYTICS",
  CONVERSATION_TITLE = "CONVERSATION_TITLE",
  END_OF_STREAM = "END_OF_STREAM"
}

export interface TokenAnalytics {
  completion_tokens: number;
  prompt_tokens: number;
  total_tokens: number;
}

export interface WebsocketResponse {
  data: string | TokenAnalytics;
  type: WebsocketResponseTypes;
}
